import React, { useMemo } from 'react';
import { Box, Divider, Typography } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { AdditionItem } from './AdditionItem';
import { formatMoney } from 'helpers/moneyFormatter';

export const RequestProductItem = ({ productRequest }) => {
  const additionCategories = useMemo(() => {
    const { additions } = productRequest;

    if (!additions.length) {
      return [];
    }

    const categories = new Map();
    additions.forEach((addition) => {
      if (!addition) {
        return;
      }

      const { category_product_option } = addition.product_option;
      if (
        category_product_option &&
        !categories.has(category_product_option.name)
      ) {
        categories.set(category_product_option.name, []);
      }

      if (category_product_option) {
        categories.get(category_product_option.name).push(addition);
      }
    });

    return Array.from(categories.entries()).map(
      ([categoryName, additions]) => ({
        name: categoryName,
        additions,
      }),
    );
  }, [productRequest]);

  return (
    <>
      <Box py={1} display="flex" flexDirection="column">
        <Typography>
          {`${productRequest.amount}x - ${productRequest.product.name} `}
          <b
            style={{
              fontSize: isMobile ? '11px' : '12px',
              float: 'right',
            }}
          >
            {formatMoney(productRequest.current_price)}
          </b>
        </Typography>

        {productRequest.note ? (
          <Typography>
            <b>Anotações:</b> {productRequest.note}
          </Typography>
        ) : null}

        {additionCategories.map((additionCategory, index) => (
          <Box
            key={String(index + 1)}
            pt={1}
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Typography style={{ fontSize: '12px' }}>
              <b style={{ textTransform: 'capitalize' }}>
                {additionCategory.name}
              </b>
            </Typography>
            {additionCategory.additions.map((addition) => (
              <AdditionItem key={addition.id} addition={addition} />
            ))}
          </Box>
        ))}
      </Box>

      <Divider />
    </>
  );
};
